
import { authorizeMe, axiosInstance } from './commonHeadApiLogic.js';

// Ensure authorization header is set before making authenticated requests
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe(); // Ensure the Authorization header is set
    return await apiFunction(...args);
  } catch (error) {
    // Handle errors as necessary
    console.error("Error in API request:", error);
    throw error;
  }
};


export const getCommissionAPI  = (role = "photographers") => {
  return withAuthorization(() =>
    axiosInstance.get(`/api/admins/${role}/commissions`)
  );
};

export const updateCommissionAPI  = (role = "photographers", data) => {
  return withAuthorization(() =>
    axiosInstance.put(`/api/admins/${role}/commissions`, data)
  );
};